class BeforeAfterCarousel extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector('.before-after-testimonials__grid');
    this.items = Array.from(this.querySelectorAll('.before-after-testimonials__card'));
    this.dots = Array.from(this.querySelectorAll('[data-bat-dot]'));
    this.prevButton = this.querySelector('.before-after-testimonials__arrow--prev');
    this.nextButton = this.querySelector('.before-after-testimonials__arrow--next');

    if (!this.list || this.items.length === 0) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.scrollToIndex(index));
    });

    if (this.prevButton) this.prevButton.addEventListener('click', () => this.step(-1));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.step(1));

    this.list.addEventListener('scroll', this.debounce(this.updateControls.bind(this), 100));
    window.addEventListener('resize', this.debounce(this.updateControls.bind(this), 150));

    this.updateControls();
  }

  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = window.setTimeout(() => fn(...args), wait);
    };
  }

  currentIndex() {
    if (!this.items.length) return 0;
    const itemWidth = this.items[0].getBoundingClientRect().width + this.gap();
    return Math.round(this.list.scrollLeft / itemWidth);
  }

  gap() {
    return parseFloat(getComputedStyle(this.list).columnGap || getComputedStyle(this.list).gap || '0');
  }

  scrollToIndex(index) {
    const clamped = Math.max(0, Math.min(index, this.items.length - 1));
    const item = this.items[clamped];
    if (!item) return;
    this.list.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
  }

  step(direction) {
    this.scrollToIndex(this.currentIndex() + direction);
  }

  updateControls() {
    const current = this.currentIndex();

    this.dots.forEach((dot, index) => {
      const active = index === current;
      dot.classList.toggle('before-after-testimonials__dot--active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (this.prevButton) this.prevButton.disabled = this.list.scrollLeft <= 0;
    if (this.nextButton) {
      const maxScroll = this.list.scrollWidth - this.list.clientWidth - 1;
      this.nextButton.disabled = this.list.scrollLeft >= maxScroll;
    }
  }
}

customElements.define('before-after-carousel', BeforeAfterCarousel);
